import './App.css';
import { useEffect, useState, useMemo } from 'react';

import LoadingLogo from './components/loadingLogo/loadingLogo';

import Application from './dashboard/application';

const API_BASE = window.location.hostname === 'localhost' 
  ? 'http://expensible.cloud' 
  : '';

function App() {
  const [user, setUser] = useState(true);
  const [loading, setLoading] = useState(true);
  const [expenses, setExpenses] = useState([{'expense_name': 'no-access'}]);
  const [filteredExpenses, setFilteredExpenses] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [userCategories, setUserCategories] = useState([]);

  useEffect(() => {
    async function fetchDashboard() {
      try {
        const response = await fetch(`${API_BASE}/express/api/dashboard/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (!response.ok) {
          setUser(false);
          throw new Error(`Server returned ${response.status}`);
        }

        const data = await response.json();
        
        setUser(data.user);
        //console.log('this is the user from express:', data);
        //console.log('Dashboard Data Received from express:', data);

        validateUserPython();

      } catch (err) {
        console.error('Error fetching dashboard:', err);
        setLoading(false);
        setUser(false);
      }
    }

    const validateUserPython = async () => { 
            try {
              const res = await fetch('/fastapi/api/expenses/', { 
                method: 'GET', 
                credentials: 'include', 
              });

              if (!res.ok) {
                throw new Error(`Python server returned ${res.status}`);
              }
              
              const data = await res.json();
              setExpenses(data.reverse());
              setLoading(false);
              console.log('python confirm:', data);
            } catch (error) {
              console.error("Fetch error:", error);
            }
          };

    fetchDashboard();

    async function fetchCategories() {
            try {
                const res = await fetch('/fastapi/api/categories/', {
                    method: 'GET', 
                credentials: 'include', 
                });

                if (!res.ok) {
                throw new Error(`Python server returned ${res.status}`);
                }

                const data = await res.json();
                setUserCategories(data)

            }
                catch (error) {
                    console.error("Fetch error:", error);
            }
        }
        fetchCategories();
  }, []);

  /* Manipulate data via- date */
  /* filters the object to be just this week from current day to past seven days */

  const thisWeek = useMemo(() => {
  const pastSevenDays = new Date();
  pastSevenDays.setDate(pastSevenDays.getDate() - 7);

  return Object.values(expenses).filter(expense => {
    const expenseDate = new Date(expense.expense_date);
    return expenseDate >= pastSevenDays;
  });
}, [expenses]); 

//console.log('this week is:', thisWeek)

/* this month */

  const thisMonth = useMemo(() => {
    const currentMonth = new Date();
    currentMonth.setDate(currentMonth.getDate() - 30);

    return Object.values(expenses).filter(expense => {
      const expenseDate = new Date(expense.expense_date);
      return expenseDate >= currentMonth;
    });
  }, [expenses]);

  //console.log('this month is:', thisMonth)

  //const [thisMonth, setThisMonth] = useState();

  /* past six months  */

  const pastSixMonths = useMemo(() => {
    const monthRange = new Date();
    monthRange.setMonth(monthRange.getMonth() - 6);

    return Object.values(expenses).filter(expense => {
      const expenseMonth = new Date(expense.expense_date);
      if (expenseMonth.getMonth() >= monthRange.getMonth() && expenseMonth.getMonth() <= new Date()) {
        return expense
      } else {
        return
      }
    });
  }, [expenses]); 

  //console.log('Past six months: ', pastSixMonths)

  //const [pastSixMonths, setPastSixMonths] = useState();

  /* Past year */
  const pastYear = useMemo(() => {
    const currentYear = new Date();
    //return console.log('this year is:', currentYear.getYear());

    return Object.values(expenses).filter(expense => {
      const expenseYear = new Date(expense.expense_date);
      return expenseYear.getFullYear() === currentYear.getFullYear();
    });

  }, [expenses]);

  //console.log('This current year', pastYear);

  // Will set all the expense dict 
  useEffect(() => {

    function sumExpensesByCategory(expenses) {
      const categoryMap = {};

      expenses.forEach(expense => {
        const catId = expense.expense_category_id;

        if(!categoryMap[catId]) {
          categoryMap[catId] = {
            ...expense,
            expense_amount: 0
          };
        }
      categoryMap[catId].expense_amount += expense.expense_amount;
      });
      return Object.values(categoryMap);
    }

    setFilteredCategories([sumExpensesByCategory(thisWeek), sumExpensesByCategory(thisMonth), sumExpensesByCategory(pastSixMonths), sumExpensesByCategory(pastYear)]);

  setFilteredExpenses([thisWeek, thisMonth, pastSixMonths, pastYear]);
}, [thisWeek, thisMonth, pastSixMonths, pastYear]);

//console.log('testing cate', filteredCategories);

  const localAddNewExpense = (item) => {
    setExpenses((prev) => [item, ...prev])
  };

  if (loading) {
    return (
      <div className="no-access">
        <LoadingLogo/>
        <p style={{ color: 'red' }}>Laoding...</p>
      </div>
    )
  };

  return (
    <div>
      {user ? (
        <div>
          <Application loading={loading} user={user} expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories} userCategories={userCategories} localAddNewExpense={localAddNewExpense}/>
        </div>
      ) : (
        <div className="no-access">
          <LoadingLogo/>
          <p style={{ color: 'red' }}>Unauthorized access. Please sign go to sign in page</p>
          <a href="//expensible.cloud/sign_in" className="no-access-button">Sign In</a>
        </div>
      )}
    </div>
  );
}

export default App;